export default {
  QuotationCustomerLang: {
    code: '产品编码',
    Level: '报价等级',
    Quotation: '客户标准价',
    VIP: 'VIP价',
    LogisticsProduct: '物流产品',
    Status: '状态',
    Disabled: '未启用',
    Enabled: '启用',
    EffectiveTime: '生效时间',

    Supplier: '产品报价ID',
    Discount: '加收比例',
    QuotationMethod: '报价方式',
    Standard: '普通报价',
    Channel: '渠道加收',
    ChannelQuotationID: '渠道报价ID',
    Exist: '渠道报价ID不存在',
    Currency: '币种',
    SourceCurrency: '源币种',
    TargetCurrency: '目标币种',
    ExchangeRate: '汇率',
    StartDate: '开始时间',
    EndDate: '结束时间',
    CreatedBy: '创建人',
    LogisticsProductCode: '物流产品编码',

    customerCode: '客户编码',
    customerName: '客户简称',
    salesmanName: '公司业务员',
    bindCustomer: '绑定客户',
    bind: '批量绑定',
    unbind: '批量解绑',
    all: '全部',
    bound: '已绑定',
    unbound: '未绑定',
    Carrier: '物流商',
    EffectiveDateRange: '生效日期范围',
    AddRate: '新增费率',
    BatchEnable: '批量启用',
    BatchDisable: '批量停用',
    ImportTemplate: '导入模版',
    Import: '导入',
    ImportFile: '文件导入',
    Export: '导出',
    Operation: '操作',
    RateNo: '费率编号',
    SurchargeRatePercent: '附加费率',
    StartTime: '开始时间',
    EndTime: '结束时间',
    FuelSurchargeRate: '燃油附加费率',
    FuelSurchargeRateAdd: '新增燃油附加费率',
    FuelSurchargeRateEdit: '编辑燃油附加费率',
    RateNoPlaceholder: '系统自动生成',
    PleaseSelectCarrier: '请选择物流商',
    PleaseSelectStatus: '请选择状态',
    Remarks: '备注',
    RemarksPlaceholder: '请输入备注信息...',
    ApiNotConfigured: '接口未配置',
    ImportApiNotConfigured: '导入接口未配置',
    FuelSurchargeRateFileName: '燃油附加费率.csv',
  }
};
